import React,{Component} from 'react';
import './ClientsLocationEdit.css';
import iconlocationlg from '../../../../image/iconlocationlg.svg'
import iconpen from '../../../../image/iconpen.svg'
import searchbule from '../../../../image/searchbule.svg'
import closeicon from '../../../../image/closeicon.svg'
import MapsNewOrder from '../../../Components/Maps/MapsNewOrder';

class ClientsLocationEdit extends Component{
    render(){
        return(
            <div className="MyClientsLocationEdit"  key={this.props.state.loc_id}>
            <div className="row col-md-10">
            <img className=" mt-3 mb-1 col-2 iconlocation" src={iconlocationlg} alt="iconlocationlg" />
            <p className="col-8 mt-2 p-0 fontsize4 ">{this.props.state.address_name}</p>
            </div>
                
             <form onSubmit={this.props.handleSubmitEditLocation}>
            <MapsNewOrder setStatecoordinatesaddress_alias={this.props.setStatecoordinatesaddress_alias} state={this.props.state} />

            <div className="col-md-8 text-center">
                     <div className="form-group pb-0 mb-1 search_div"id="pac-container">
                     <img className="ml-1  img_input" src={searchbule} alt="search"  />
                         <input type="text " id="pac-input" className={"px-5 search_input form-control badge-pill " + (this.props.state.address_nameError ? 'is-invalid' : '')} placeholder="اختار عنوان  " name="address_name" value={this.props.state.address_name} onChange={this.props.handleChange} required />
                               
                     </div>
                     <div style={{ fontSize: 12, color: "red" }} className="text-left">
                         {this.props.state.address_nameError}
                     </div> 
                     
                     <div id="map"></div>
                     <div className="form-group col-12 text-right mt-2">
                     <label >تفاصيل للعنوان</label>
                     <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.address_aliasError ? 'is-invalid' : '')} placeholder="الشقه - الدور - العماره .." name="address_alias" value={this.props.state.address_alias} onChange={this.props.handleChange}  required/>
                     <div style={{ fontSize: 12, color: "red" }}>
                         {this.props.state.address_aliasError}
                     </div>                
                 </div>
             </div> 

             
             <div className="col-md-8 d-flex justify-content-around  flex-wrap">
                 <button type="submit" className="btn badge-pill p-2 pl-1 px-3 mt-2 border shadow bg-white" ><img className="ml-1" src={iconpen} alt="pen" disabled={(this.props.state.inRequest?true:false)}/>حفظ التعديلات</button>
                 <button onClick={this.props.handleSubmitDeleteLocation} className="btn badge-pill p-2 pl-1 px-3 mt-2 border shadow   bg-danger text-white" disabled={(this.props.state.inRequest?true:false)}><img className="ml-1 " src={closeicon} alt="close" /> حذف  </button>
             </div>
             </form>
         </div>


        )
    }
}
export default ClientsLocationEdit;